module.exports = __webpack_public_path__ + "static/media/monzo.d23a7f28.svg";